import React, {useCallback, useRef} from 'react'
import {createPortal} from 'react-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import {DigitalVosFormPanel, DigitalVosFormPanelHandle} from './DigitalVosFormPanel'
import type {BuildDigitalVosFormInput} from './digitalVosFormTypes'
import toaster from '../../../../../Utils/toaster'

export type DigitalVosFormModalProps = {
  show: boolean
  onClose: () => void
  fileName: string
  input: BuildDigitalVosFormInput
  /** fullscreen = assignment flow; popup = bulk VOS / inline grids */
  layout?: 'fullscreen' | 'popup'
}

export const DigitalVosFormModal: React.FC<DigitalVosFormModalProps> = ({
  show,
  onClose,
  fileName,
  input,
  layout = 'fullscreen',
}) => {
  const panelRef = useRef<DigitalVosFormPanelHandle>(null)

  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  const handleDownloadError = useCallback((message: string) => {
    toaster('error', message)
  }, [])

  if (!show) return null

  if (layout === 'popup') {
    return createPortal(
      <div
        className='modal fade show d-block'
        style={{backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 1055}}
        role='dialog'
        aria-modal='true'
        aria-labelledby='digital-vos-form-popup-title'
      >
        <div className='modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable'>
          <div className='modal-content'>
            <div className='modal-header py-3 flex-shrink-0'>
              <h4 className='modal-title' id='digital-vos-form-popup-title'>
                Digital VOS form
              </h4>
              <div className='d-flex align-items-center gap-2 ms-auto'>
                <button
                  type='button'
                  className='btn btn-sm btn-primary'
                  onClick={() => void panelRef.current?.downloadPdf()}
                >
                  Download PDF
                </button>
                <button
                  type='button'
                  className='btn btn-icon btn-sm btn-active-light-primary'
                  aria-label='Close'
                  onClick={handleClose}
                >
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                </button>
              </div>
            </div>
            <div className='modal-body p-0' style={{maxHeight: 'min(75vh, 820px)', overflow: 'auto'}}>
              <DigitalVosFormPanel
                ref={panelRef}
                standalone={false}
                input={input}
                fileName={fileName}
                onDownloadError={handleDownloadError}
              />
            </div>
          </div>
        </div>
      </div>,
      document.body,
    )
  }

  return (
    <div
      className='modal fade show d-block'
      style={{backgroundColor: 'rgba(0,0,0,0.55)'}}
      role='dialog'
      aria-modal='true'
    >
      <div className='modal-dialog modal-fullscreen'>
        <div className='modal-content border-0'>
          <DigitalVosFormPanel
            standalone
            input={input}
            fileName={fileName}
            onClose={handleClose}
            onDownloadError={handleDownloadError}
          />
        </div>
      </div>
    </div>
  )
}
